module.exports = __webpack_public_path__ + "img/folder-search-alternate.f96058b6.svg";